import { apiFetch } from './client';
import type { UserRole } from '@grid2/shared-types';

/**
 * Multi-org membership + session-switch client (ADR-0010 Phase 2).
 *
 * `GET /api/orgs` returns only the ACTIVE memberships of the identity behind
 * the caller's session; `POST /api/session/switch-org` re-mints the session
 * cookie against another of those orgs (403 `NOT_A_MEMBER` if the target org
 * membership was revoked between listing and the click).
 */

/** One org row in the `GET /api/orgs` response. */
export interface OrgListEntry {
  orgId: string;
  name: string;
  slug: string;
  role: UserRole;
  lastUsedAt?: string;
}

/** The switched-to org's display fields, as returned by `switch-org`. */
export interface OrgSummary {
  orgId: string;
  name: string;
  slug: string;
}

export interface SwitchOrgResult {
  org: OrgSummary;
  role: UserRole;
  region: string;
}

export const orgsApi = {
  list: () => apiFetch<{ orgs: OrgListEntry[] }>('/api/orgs'),

  switchOrg: (orgId: string) =>
    apiFetch<SwitchOrgResult>('/api/session/switch-org', {
      method: 'POST',
      body: JSON.stringify({ orgId }),
    }),
};
